export const PopupPosition = {
    at: { x: 'center' as const, y: 'center' as const },
    my: { x: 'center' as const, y: 'center' as const },
    of: "window",
    offset: { x: 0, y: -100 }
};